export default {
  'ar-AE': {
    buttonLabel: 'عرض المقترحات',
    countAnnouncement:
      '{optionCount, plural, one {# خيار} other {# خيارات}} متاحة.',
    focusAnnouncement:
      '{isGroupChange, select, true {المجموعة المدخلة {groupTitle}, مع {groupCount, plural, one {# خيار} other {# خيارات}}. } other {}}{optionText}{isSelected, select, true {, محدد} other {}}',
    listboxLabel: 'مقترحات',
    selectedAnnouncement: '{optionText}، محدد',
  },
  'bg-BG': {
    buttonLabel: 'Покажи предложения',
    countAnnouncement:
      '{optionCount, plural, one {# опция} other {# опции}} на разположение.',
    focusAnnouncement:
      '{isGroupChange, select, true {Въведена група {groupTitle}, с {groupCount, plural, one {# опция} other {# опции}}. } other {}}{optionText}{isSelected, select, true {, избрани} other {}}',
    listboxLabel: 'Предложения',
    selectedAnnouncement: '{optionText}, избрани',
  },
  'cs-CZ': {
    buttonLabel: 'Zobrazit doporučení',
    countAnnouncement:
      'K dispozici {optionCount, plural, one {je # možnost} other {jsou/je # možnosti/-í}}.',
    focusAnnouncement:
      '{isGroupChange, select, true {Zadaná skupina „{groupTitle}“ {groupCount, plural, one {s # možností} other {se # možnostmi}}. } other {}}{optionText}{isSelected, select, true { (vybráno)} other {}}',
    listboxLabel: 'Návrhy',
    selectedAnnouncement: '{optionText}, vybráno',
  },
  'da-DK': {
    buttonLabel: 'Vis forslag',
    countAnnouncement:
      '{optionCount, plural, one {# mulighed tilgængelig} other {# muligheder tilgængelige}}.',
    focusAnnouncement:
      '{isGroupChange, select, true {Angivet gruppe {groupTitle}, med {groupCount, plural, one {# mulighed} other {# muligheder}}. } other {}}{optionText}{isSelected, select, true {, valgt} other {}}',
    listboxLabel: 'Forslag',
    selectedAnnouncement: '{optionText}, valgt',
  },
  'de-DE': {
    buttonLabel: 'Empfehlungen anzeigen',
    countAnnouncement:
      '{optionCount, plural, one {# Option} other {# Optionen}} verfügbar.',
    focusAnnouncement:
      '{isGroupChange, select, true {Eingetretene Gruppe {groupTitle}, mit {groupCount, plural, one {# Option} other {# Optionen}}. } other {}}{optionText}{isSelected, select, true {, ausgewählt} other {}}',
    listboxLabel: 'Empfehlungen',
    selectedAnnouncement: '{optionText}, ausgewählt',
  },
  'el-GR': {
    buttonLabel: 'Προβολή προτάσεων',
    countAnnouncement:
      '{optionCount, plural, one {# επιλογή} other {# επιλογές }} διαθέσιμες.',
    focusAnnouncement:
      '{isGroupChange, select, true {Εισαγμένη ομάδα {groupTitle}, με {groupCount, plural, one {# επιλογή} other {# επιλογές}}. } other {}}{optionText}{isSelected, select, true {, επιλεγμένο} other {}}',
    listboxLabel: 'Προτάσεις',
    selectedAnnouncement: '{optionText}, επιλέχθηκε',
  },
  'en-US': {
    focusAnnouncement:
      '{isGroupChange, select, true {Entered group {groupTitle}, with {groupCount, plural, one {# option} other {# options}}. } other {}}{optionText}{isSelected, select, true {, selected} other {}}',
    countAnnouncement:
      '{optionCount, plural, one {# option} other {# options}} available.',
    selectedAnnouncement: '{optionText}, selected',
    buttonLabel: 'Show suggestions',
    listboxLabel: 'Suggestions',
  },
  'es-ES': {
    buttonLabel: 'Mostrar sugerencias',
    countAnnouncement:
      '{optionCount, plural, one {# opción} other {# opciones}} disponible(s).',
    focusAnnouncement:
      '{isGroupChange, select, true {Se ha unido al grupo {groupTitle}, con {groupCount, plural, one {# opción} other {# opciones}}. } other {}}{optionText}{isSelected, select, true {, seleccionado} other {}}',
    listboxLabel: 'Sugerencias',
    selectedAnnouncement: '{optionText}, seleccionado',
  },
  'et-EE': {
    buttonLabel: 'Kuva soovitused',
    countAnnouncement:
      '{optionCount, plural, one {# valik} other {# valikud}} saadaval.',
    focusAnnouncement:
      '{isGroupChange, select, true {Sisestatud rühm {groupTitle}, valikuga {groupCount, plural, one {# valik} other {# valikud}}. } other {}}{optionText}{isSelected, select, true {, valitud} other {}}',
    listboxLabel: 'Soovitused',
    selectedAnnouncement: '{optionText}, valitud',
  },
  'fi-FI': {
    buttonLabel: 'Näytä ehdotukset',
    countAnnouncement:
      '{optionCount, plural, one {# vaihtoehto} other {# vaihtoehdot}} saatavilla.',
    focusAnnouncement:
      '{isGroupChange, select, true {Mentiin ryhmään {groupTitle}, {groupCount, plural, one {# vaihtoehdon} other {# vaihtoehdon}} kanssa.} other {}}{optionText}{isSelected, select, true {, valittu} other {}}',
    listboxLabel: 'Ehdotukset',
    selectedAnnouncement: '{optionText}, valittu',
  },
  'fr-FR': {
    buttonLabel: 'Afficher les suggestions',
    countAnnouncement:
      '{optionCount, plural, one {# option} other {# options}} disponible(s).',
    focusAnnouncement:
      '{isGroupChange, select, true {Groupe {groupTitle} saisi, avec {groupCount, plural, one {# option} other {# options}}. } other {}}{optionText}{isSelected, select, true {, sélectionné(s)} other {}}',
    listboxLabel: 'Suggestions',
    selectedAnnouncement: '{optionText}, sélectionné',
  },
  'he-IL': {
    buttonLabel: 'הצג הצעות',
    countAnnouncement:
      '{optionCount, plural, one {אפשרות #} other {# אפשרויות}} במצב זמין.',
    focusAnnouncement:
      '{isGroupChange, select, true {נכנס לקבוצה {groupTitle}, עם {groupCount, plural, one {אפשרות #} other {# אפשרויות}}. } other {}}{optionText}{isSelected, select, true {, נבחר} other {}}',
    listboxLabel: 'הצעות',
    selectedAnnouncement: '{optionText}, נבחר',
  },
  'hr-HR': {
    buttonLabel: 'Prikaži prijedloge',
    countAnnouncement:
      'Dostupno još: {optionCount, plural, one {# opcija} other {# opcije/a}}.',
    focusAnnouncement:
      '{isGroupChange, select, true {Unesena skupina {groupTitle}, s {groupCount, plural, one {# opcijom} other {# opcije/a}}. } other {}}{optionText}{isSelected, select, true {, odabranih} other {}}',
    listboxLabel: 'Prijedlozi',
    selectedAnnouncement: '{optionText}, odabrano',
  },
  'hu-HU': {
    buttonLabel: 'Javaslatok megjelenítése',
    countAnnouncement:
      '{optionCount, plural, one {# lehetőség} other {# lehetőség}} áll rendelkezésre.',
    focusAnnouncement:
      '{isGroupChange, select, true {Belépett a(z) {groupTitle} csoportba, amely {groupCount, plural, one {# lehetőséget} other {# lehetőséget}} tartalmaz. } other {}}{optionText}{isSelected, select, true {, kijelölve} other {}}',
    listboxLabel: 'Javaslatok',
    selectedAnnouncement: '{optionText}, kijelölve',
  },
  'it-IT': {
    buttonLabel: 'Mostra suggerimenti',
    countAnnouncement:
      '{optionCount, plural, one {# opzione disponibile} other {# opzioni disponibili}}.',
    focusAnnouncement:
      '{isGroupChange, select, true {Ingresso nel gruppo {groupTitle}, con {groupCount, plural, one {# opzione} other {# opzioni}}. } other {}}{optionText}{isSelected, select, true {, selezionato} other {}}',
    listboxLabel: 'Suggerimenti',
    selectedAnnouncement: '{optionText}, selezionato',
  },
  'ja-JP': {
    buttonLabel: '候補を表示',
    countAnnouncement:
      '{optionCount, plural, one {# 個のオプション} other {# 個のオプション}}を利用できます。',
    focusAnnouncement:
      '{isGroupChange, select, true {入力されたグループ {groupTitle}、{groupCount, plural, one {# 個のオプション} other {# 個のオプション}}を含む。} other {}}{optionText}{isSelected, select, true {、選択済み} other {}}',
    listboxLabel: '候補',
    selectedAnnouncement: '{optionText}、選択済み',
  },
  'ko-KR': {
    buttonLabel: '제안 사항 표시',
    countAnnouncement:
      '{optionCount, plural, one {#개 옵션} other {#개 옵션}}을 사용할 수 있습니다.',
    focusAnnouncement:
      '{isGroupChange, select, true {입력한 그룹 {groupTitle}, {groupCount, plural, one {#개 옵션} other {#개 옵션}}. } other {}}{optionText}{isSelected, select, true {, 선택됨} other {}}',
    listboxLabel: '제안',
    selectedAnnouncement: '{optionText}, 선택됨',
  },
  'lt-LT': {
    buttonLabel: 'Rodyti pasiūlymus',
    countAnnouncement:
      'Yra {optionCount, plural, one {# parinktis} other {# parinktys (-ių)}}.',
    focusAnnouncement:
      '{isGroupChange, select, true {Įvesta grupė {groupTitle}, su {groupCount, plural, one {# parinktimi} other {# parinktimis (-ių)}}. } other {}}{optionText}{isSelected, select, true {, pasirinkta} other {}}',
    listboxLabel: 'Pasiūlymai',
    selectedAnnouncement: '{optionText}, pasirinkta',
  },
  'lv-LV': {
    buttonLabel: 'Rādīt ieteikumus',
    countAnnouncement:
      'Pieejamo opciju skaits: {optionCount, plural, one {# opcija} other {# opcijas}}.',
    focusAnnouncement:
      '{isGroupChange, select, true {Ievadīta grupa {groupTitle}, ar {groupCount, plural, one {# opciju} other {# opcijām}}. } other {}}{optionText}{isSelected, select, true {, atlasīta} other {}}',
    listboxLabel: 'Ieteikumi',
    selectedAnnouncement: '{optionText}, atlasīta',
  },
  'nb-NO': {
    buttonLabel: 'Vis forslag',
    countAnnouncement:
      '{optionCount, plural, one {# alternativ} other {# alternativer}} finnes.',
    focusAnnouncement:
      '{isGroupChange, select, true {Angitt gruppe {groupTitle}, med {groupCount, plural, one {# alternativ} other {# alternativer}}. } other {}}{optionText}{isSelected, select, true {, valgt} other {}}',
    listboxLabel: 'Forslag',
    selectedAnnouncement: '{optionText}, valgt',
  },
  'nl-NL': {
    buttonLabel: 'Suggesties weergeven',
    countAnnouncement:
      '{optionCount, plural, one {# optie} other {# opties}} beschikbaar.',
    focusAnnouncement:
      '{isGroupChange, select, true {Groep {groupTitle} ingevoerd met {groupCount, plural, one {# optie} other {# opties}}. } other {}}{optionText}{isSelected, select, true {, geselecteerd} other {}}',
    listboxLabel: 'Suggesties',
    selectedAnnouncement: '{optionText}, geselecteerd',
  },
  'pl-PL': {
    buttonLabel: 'Wyświetlaj sugestie',
    countAnnouncement:
      'dostępna/dostępne(-nych) {optionCount, plural, one {# opcja} other {# opcje(-i)}}.',
    focusAnnouncement:
      '{isGroupChange, select, true {Dołączono do grupy {groupTitle}, z {groupCount, plural, one {# opcją} other {# opcjami}}. } other {}}{optionText}{isSelected, select, true {, wybrano} other {}}',
    listboxLabel: 'Sugestie',
    selectedAnnouncement: '{optionText}, wybrano',
  },
  'pt-BR': {
    buttonLabel: 'Mostrar sugestões',
    countAnnouncement:
      '{optionCount, plural, one {# opção} other {# opções}} disponível.',
    focusAnnouncement:
      '{isGroupChange, select, true {Grupo inserido {groupTitle}, com {groupCount, plural, one {# opção} other {# opções}}. } other {}}{optionText}{isSelected, select, true {, selecionado} other {}}',
    listboxLabel: 'Sugestões',
    selectedAnnouncement: '{optionText}, selecionado',
  },
  'pt-PT': {
    buttonLabel: 'Apresentar sugestões',
    countAnnouncement:
      '{optionCount, plural, one {# opção} other {# opções}} disponível.',
    focusAnnouncement:
      '{isGroupChange, select, true {Grupo introduzido {groupTitle}, com {groupCount, plural, one {# opção} other {# opções}}. } other {}}{optionText}{isSelected, select, true {, selecionado} other {}}',
    listboxLabel: 'Sugestões',
    selectedAnnouncement: '{optionText}, selecionado',
  },
  'ro-RO': {
    buttonLabel: 'Afișare sugestii',
    countAnnouncement:
      '{optionCount, plural, one {# opțiune} other {# opțiuni}} disponibile.',
    focusAnnouncement:
      '{isGroupChange, select, true {Grup {groupTitle} introdus, cu {groupCount, plural, one {# opțiune} other {# opțiuni}}. } other {}}{optionText}{isSelected, select, true {, selectat} other {}}',
    listboxLabel: 'Sugestii',
    selectedAnnouncement: '{optionText}, selectat',
  },
  'ru-RU': {
    buttonLabel: 'Показать предложения',
    countAnnouncement:
      '{optionCount, plural, one {# параметр} other {# параметров}} доступно.',
    focusAnnouncement:
      '{isGroupChange, select, true {Введенная группа {groupTitle}, с {groupCount, plural, one {# параметром} other {# параметрами}}. } other {}}{optionText}{isSelected, select, true {, выбранными} other {}}',
    listboxLabel: 'Предложения',
    selectedAnnouncement: '{optionText}, выбрано',
  },
  'sk-SK': {
    buttonLabel: 'Zobraziť návrhy',
    countAnnouncement:
      '{optionCount, plural, one {# možnosť} other {# možnosti/-í}} k dispozícii.',
    focusAnnouncement:
      '{isGroupChange, select, true {Zadaná skupina {groupTitle}, s {groupCount, plural, one {# možnosťou} other {# možnosťami}}. } other {}}{optionText}{isSelected, select, true {, vybraté} other {}}',
    listboxLabel: 'Návrhy',
    selectedAnnouncement: '{optionText}, vybraté',
  },
  'sl-SI': {
    buttonLabel: 'Prikaži predloge',
    countAnnouncement:
      'Na voljo je {optionCount, plural, one {# opcija} other {# opcije}}.',
    focusAnnouncement:
      '{isGroupChange, select, true {Vnesena skupina {groupTitle}, z {groupCount, plural, one {# opcija} other {# opcije}}. } other {}}{optionText}{isSelected, select, true {, izbrano} other {}}',
    listboxLabel: 'Predlogi',
    selectedAnnouncement: '{optionText}, izbrano',
  },
  'sr-SP': {
    buttonLabel: 'Prikaži predloge',
    countAnnouncement:
      'Dostupno još: {optionCount, plural, one {# opcija} other {# opcije/a}}.',
    focusAnnouncement:
      '{isGroupChange, select, true {Unesena grupa {groupTitle}, s {groupCount, plural, one {# opcijom} other {# optione/a}}. } other {}}{optionText}{isSelected, select, true {, izabranih} other {}}',
    listboxLabel: 'Predlozi',
    selectedAnnouncement: '{optionText}, izabrano',
  },
  'sv-SE': {
    buttonLabel: 'Visa förslag',
    countAnnouncement:
      '{optionCount, plural, one {# alternativ} other {# alternativ}} tillgängliga.',
    focusAnnouncement:
      '{isGroupChange, select, true {Ingick i gruppen {groupTitle} med {groupCount, plural, one {# alternativ} other {# alternativ}}. } other {}}{optionText}{isSelected, select, true {, valda} other {}}',
    listboxLabel: 'Förslag',
    selectedAnnouncement: '{optionText}, valda',
  },
  'tr-TR': {
    buttonLabel: 'Önerileri göster',
    countAnnouncement:
      '{optionCount, plural, one {# seçenek} other {# seçenekler}} kullanılabilir.',
    focusAnnouncement:
      '{isGroupChange, select, true {Girilen grup {groupTitle}, ile {groupCount, plural, one {# seçenek} other {# seçenekler}}. } other {}}{optionText}{isSelected, select, true {, seçildi} other {}}',
    listboxLabel: 'Öneriler',
    selectedAnnouncement: '{optionText}, seçildi',
  },
  'uk-UA': {
    buttonLabel: 'Показати пропозиції',
    countAnnouncement:
      '{optionCount, plural, one {# параметр} other {# параметри(-ів)}} доступно.',
    focusAnnouncement:
      '{isGroupChange, select, true {Введена група {groupTitle}, з {groupCount, plural, one {# параметр} other {# параметри(-ів)}}. } other {}}{optionText}{isSelected, select, true {, вибрано} other {}}',
    listboxLabel: 'Пропозиції',
    selectedAnnouncement: '{optionText}, вибрано',
  },
  'zh-CN': {
    buttonLabel: '显示建议',
    countAnnouncement:
      '有 {optionCount, plural, one {# 个选项} other {# 个选项}}可用。',
    focusAnnouncement:
      '{isGroupChange, select, true {进入了 {groupTitle} 组，其中有 {groupCount, plural, one {# 个选项} other {# 个选项}}. } other {}}{optionText}{isSelected, select, true {, 已选择} other {}}',
    listboxLabel: '建议',
    selectedAnnouncement: '{optionText}, 已选择',
  },
  'zh-TW': {
    buttonLabel: '顯示建議',
    countAnnouncement:
      '{optionCount, plural, one {# 選項} other {# 選項}} 可用。',
    focusAnnouncement:
      '{isGroupChange, select, true {輸入的群組 {groupTitle}, 有 {groupCount, plural, one {# 選項} other {# 選項}}. } other {}}{optionText}{isSelected, select, true {, 已選取} other {}}',
    listboxLabel: '建議',
    selectedAnnouncement: '{optionText}, 已選取',
  },
};
